var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-list",style:({ '--primary-bg': _vm.$root.color_schema.primary })},[(_vm.menu.object === 'custom')?[(_vm.menu.url && _vm.menu.url != '')?_c('a',{staticClass:"nav-link",attrs:{"title":_vm.menu.title,"href":_vm.menu.url}},[(_vm.menu.menu_item_icon)?_c('object',{class:{
          'grayscale-invert-light': !_vm.getContrastYIQ(
            _vm.$root.color_schema.primary
          ),
          'grayscale-invert-dark': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
        },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
          'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
          'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
        }},[_vm._v(_vm._s(_vm.menu.title))])]):[(_vm.menu.menu_item_icon)?_c('object',{class:{
          'nav-link': true,
          'grayscale-invert-light': !_vm.getContrastYIQ(
            _vm.$root.color_schema.primary
          ),
          'grayscale-invert-dark': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
        },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
          'span-text nav-link': true,
          'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
          'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
        }},[_vm._v(_vm._s(_vm.menu.title))])]]:[(_vm.$root.enable_piwik_reload)?[_c('a',{staticClass:"nav-link",attrs:{"title":_vm.menu.title,"href":_vm.getRouteLink(_vm.menu.slug, _vm.menu.object, _vm.menu.base_slug)}},[(_vm.menu.menu_item_icon)?_c('object',{class:{
            'grayscale-invert-light': !_vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
            'grayscale-invert-dark': _vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
          },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
            'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
          }},[_vm._v(_vm._s(_vm.menu.title))])])]:[_c('router-link',{staticClass:"nav-link",attrs:{"title":_vm.menu.title,"tag":"a","to":_vm.getRouteLink(_vm.menu.slug, _vm.menu.object, _vm.menu.base_slug)}},[(_vm.menu.menu_item_icon)?_c('object',{class:{
            'grayscale-invert-light': !_vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
            'grayscale-invert-dark': _vm.getContrastYIQ(
              _vm.$root.color_schema.primary
            ),
          },attrs:{"data":_vm.menu.menu_item_icon,"type":"image/svg+xml"}}):_vm._e(),_vm._v(" "),_c('span',{class:{
            'text-nav': _vm.getContrastYIQ(_vm.$root.color_schema.primary),
            'text-white': !_vm.getContrastYIQ(_vm.$root.color_schema.primary),
          }},[_vm._v(_vm._s(_vm.menu.title))])])]],_vm._v(" "),(_vm.menu.children && _vm.menu.children.length > 0)?[_c('ChildMenu',{attrs:{"menus":_vm.menu.children,"left":"0%","top":"100%"}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57ce095a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/NavMenu.vue
// module id = 488
// module chunks = 1